<template>
    <div class="homepage__footer">
        <div class="footer__content">
            <div class="footer__section logo">
                <div>
                    <img src="/images/logo-with-rectangles.png" alt="Logo" />
                </div>
            </div>
            <div class="footer__section connect">
                <div class="footer__section__heading">
                    {{ $t('footer.connect') }}
                </div>
                <a :href="fbCommunityLink" class="connect__link">
                    <img src="/images/team-group.svg" alt="teacher_group" />
                    <span>{{ $t('footer.teacherGroup') }}</span>
                </a>
                <a :href="twitterLink" class="connect__link">
                    <img src="/images/twitter-inverted.svg" alt="twitter" />
                    <span>Twitter</span>
                </a>
                <a
                    href="https://www.instagram.com/99mathgame/"
                    class="connect__link"
                >
                    <img src="/images/instagram-inverted.svg" alt="instagram" />
                    <span>Instagram</span>
                </a>
                <a :href="fbPageLink" class="connect__link">
                    <img src="/images/facebook-inverted.svg" alt="facebook" />
                    <span>Facebook</span>
                </a>
                <a
                    href="https://www.linkedin.com/company/99math/"
                    class="connect__link"
                >
                    <img src="/images/linkedin-inverted.svg" alt="linkedin" />
                    <span>Linkedin</span>
                </a>
            </div>
            <div class="footer__section team">
                <div class="footer__section__heading">
                    99math {{ $t('footer.team') }}
                </div>
                <a
                    v-if="user"
                    class="text"
                    href="#"
                    @click.prevent="openCustomerSupportModal"
                >
                    Customer Support
                </a>
                <div class="team__link">
                    <a
                        href="http://faq.99math.com/"
                        target="_blank"
                        rel="noopener"
                        @click="clickOnFAQLink"
                    >
                        FAQ
                    </a>
                </div>
                <div class="text">{{ $t('footer.emailUs') }}:</div>
                <div class="text">hello@99math.com</div>
                <div class="text">{{ $t('footer.join') }}:</div>
                <div class="team__link">
                    <a href="https://careers.99math.com/">careers.99math.com</a>
                </div>
            </div>
            <div class="footer__section languages">
                <div class="footer__section__heading">
                    <img src="/images/universal.svg" alt="universal" />
                    {{ $t('footer.languages') }}
                </div>
                <select
                    id="language"
                    v-model="selectedLang"
                    name="language"
                    @change="handleLangChange($event)"
                >
                    <option
                        v-for="lang in allLanguages"
                        :key="lang.key"
                        :value="lang.title"
                    >
                        {{ lang.title }}
                    </option>
                </select>

                <a :href="getPrivacyPolicyLink" target="_blank" rel="noopener">
                    {{ $t('footer.privacyPolicy') }}
                </a>
                <a :href="getTermsOfUseLink" target="_blank" rel="noopener">
                    {{ $t('footer.termsOfUse') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
    getFbGroupLink,
    getFbPageLink,
    getPrivacyPolicyLink,
    getTermsOfUseLink,
    getTwitterLink,
} from '@/core/helpers/utils';
import {
    ANONYMOUSEVENTS,
    AnonymousMixpanelService,
} from '@/core/services/MixPanelService/AnonymousMixPanelService.js';

export default {
    data() {
        return {
            selectedLang: '',
        };
    },
    computed: {
        ...mapGetters({
            currentLanguage: 'getCurrentLanguage',
            allLanguages: 'getAllLanguages',
            user: 'user',
        }),
        fbCommunityLink() {
            return getFbGroupLink(this.currentLanguage);
        },
        twitterLink() {
            return getTwitterLink(this.currentLanguage);
        },
        fbPageLink() {
            return getFbPageLink(this.currentLanguage);
        },
        getPrivacyPolicyLink() {
            return getPrivacyPolicyLink(this.currentLanguage);
        },
        getTermsOfUseLink() {
            return getTermsOfUseLink(this.currentLanguage);
        },
    },
    created() {
        this.selectedLang = this.allLanguages[this.currentLanguage].title;
    },
    methods: {
        ...mapActions(['setLanguage']),
        handleLangChange(event) {
            this.setLanguage(
                Object.values(this.allLanguages).find(
                    (lang) => lang.title === event.target.value,
                ).key,
            );
        },
        openCustomerSupportModal() {
            this.$emitter.emit('openCustomerSupportModal');
        },
        clickOnFAQLink() {
            new AnonymousMixpanelService().track(
                ANONYMOUSEVENTS.USER_CLICK_FAQ,
            );
        },
    },
};
</script>

<style lang="scss">
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

.homepage__footer {
    background-color: #572598;
    position: relative;
    z-index: 2;
    color: white;

    .footer__content {
        display: grid;
        grid-template-areas: 'logo connect team languages';
        gap: 10px;
        min-height: 240px;
        padding: 40px;
        background-color: #512b92;

        a,
        a:active,
        a:visited {
            color: white;
        }

        a {
            padding-left: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 16px;

            img {
                height: 14px;
                width: 14px;
                margin-right: 12px;
            }
        }

        .footer__section {
            box-sizing: border-box;
            font-size: 18px;

            &__heading {
                white-space: nowrap;
                padding: 12px 14px;
                border-radius: 30px;
                margin-bottom: 20px;
                font-weight: bold;
                display: inline-block;
                background-color: #45257c;
                background-color: rgba($color: #000000, $alpha: 0.2);
            }
        }

        .logo {
            grid-area: logo;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            img {
                width: 86%;
                min-width: 100px;
            }
        }

        .team {
            grid-area: team;

            .text {
                padding-left: 14px;
                font-weight: 600;
                margin-bottom: 24px;
            }

            &__link {
                font-weight: 600;
            }
        }

        .connect {
            grid-area: connect;
        }

        .languages {
            grid-area: languages;

            #language {
                border: 1px solid #f0b53c;
                background-color: #512b92;
                color: white;
                font-size: 18px;
                font-weight: bold;
                text-align: center;
                padding: 6px 12px;
                border-radius: 6px;
                margin-bottom: 1rem;
                cursor: pointer;
            }

            .footer__section__heading {
                display: flex;
                align-items: center;
                justify-content: center;
                max-width: 120px;

                img {
                    margin-right: 8px;
                    height: 18px;
                    width: 18px;
                }
            }
        }
    }
}
@include mq($w-max-sm, max) {
    .homepage__footer {
        .footer__content {
            grid-template-areas:
                'team connect'
                'languages logo';
            padding: 20px 10px;
            gap: 20px;
            justify-items: center;

            .footer__section {
                font-size: 14px;
            }
        }
    }
}
</style>
